import { Network } from 'lucide-react';
import { forwardRef } from 'react';
import { DeckardIcon, DeckardIconProps } from './DeckardIcon';

export const GraphIcon: DeckardIcon = forwardRef<SVGSVGElement, DeckardIconProps>(
  ({ circle, double, style, ...props }, ref) => (
    <Network
      ref={ref}
      className="deckard-icon"
      style={{ transform: 'rotate(90deg)', ...style }}
      {...props}
    />
  ),
);
